import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Icon, LoadingButton, Typography } from '@myn/mui';

type Props = {
  isLoading: boolean;
  isDisabled: boolean;
  isLabelVisible?: boolean;
  onClick: () => void;
};

const PredictiveButton: FC<Props> = ({
  isLoading,
  isDisabled,
  isLabelVisible = true,
  onClick,
}) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <LoadingButton
      size="medium"
      loadingPosition="start"
      variant="contained"
      color="primary"
      loading={isLoading}
      startIcon={!isLoading && <Icon component="MagicWandFilled" />}
      disabled={isDisabled}
      onClick={onClick}
    >
      {isLabelVisible ? (
        <Typography variant="bodyShort01">{t('Predictive')}</Typography>
      ) : null}
    </LoadingButton>
  );
};

export default PredictiveButton;
